import { createRoot } from 'react-dom/client';
import App from './components/app';

const root = createRoot(document.querySelector('#app') as HTMLElement);
root.render(<App />);
